import { Text } from "grommet";
import { TextProps } from "grommet/components/Text";

interface Props extends Omit<TextProps, "weight" | "size"> {
  children: any;
}

export const TableHeaderText = ({ ...res }: Props) => <Text size={"small"} weight={"bold"} {...res} />;
